// Function to convert camelCase to snake_case
const toSnakeCase = (str: string): string => {
  return str.replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`);
};

// Function to convert an object's keys from camelCase to snake_case
export const convertKeysToSnakeCase = (obj: any) => {
  const newObj: any = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = toSnakeCase(key);
      newObj[newKey] = obj[key];
    }
  }
  return newObj;
};

const STATUS_VALUE: Record<string, {}> = {
  completed: {
    bgcolor: "#ECFDF3",
    color: "#379E66",
    px: 2,
  },
  success: {
    bgcolor: "#ECFDF3",
    color: "#379E66",
    px: 2,
  },
  pending: {
    color: "#F9A000",
    bgcolor: "#FFFAEB",
    px: 2,
  },
  failed: {
    color: "#DA4733",
    bgcolor: "#FEF3F2",
    px: 2,
  },
  expired: {
    color: "#DA4733",
    bgcolor: "#FEF3F2",
    px: 2,
  },
};

export const getStatusStyle = (val: string): any => {
  return STATUS_VALUE[val?.toLowerCase()];
};

export const calculateFlightDuration = (
  departureTime: string,
  arrivalTime: string
) => {
  if (!departureTime || !arrivalTime) {
    return {
      totalMinutes: 0,
      hours: 0,
      minutes: 0,
      formatted: "0h 0m",
    };
  }
  const departure = new Date(departureTime);
  const arrival = new Date(arrivalTime);

  const diffInMs = arrival.getTime() - departure.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;

  return {
    totalMinutes: diffInMinutes,
    hours,
    minutes,
    formatted: `${hours}h ${minutes}m`,
  };
};
